import React from 'react';
import PropTypes from 'prop-types';
import { buildThumbnailUrl, SanitizeHtml } from '@bd/bdcore-utilities';
import withData from '@bd/bdcore-data';
import { get } from 'lodash';
import LightBox from '@bd/bdui-lightbox';
import PageHelmet from '@bd/bdcore-pagehelmet';


import Header from '../../components/Header';
import Footer from '../../components/Footer';
import InsideHeader from '../../components/InsideHeader';
import PageIntroBanner from '../../components/PageIntroBanner';
import MenuBuyingGuide from '../../components/MenuBuyingGuide';

function Financing({ page }) {
  if (!page) {
    return null;
  }
  return (
    <div>
      <InsideHeader h1="Financing Your New Home" background={get(page, 'page_image.contentUrl')} />
      <PageHelmet page={page} />
      <Header />
      <MenuBuyingGuide />
      <PageIntroBanner
        h2={get(page, 'intro_banner[0].top_headline', '')}
        h3={get(page, 'intro_banner[0].main_headline')}
        h4=""
        p={get(page, 'intro_banner[0].paragraph')}
        background={get(page, 'intro_banner[0].photo.contentUrl')}
      />
      {
        page.lenders.map(item => (
          <section key={item.name_of_company} className="section-pd section-alternate">
            <div className="full-width-headline-left">
              <div className="container">
                <h3>{item.name_of_company}</h3>
              </div>
              <div className="lines" />
            </div>
            <div className="container">
              <div className="row">
                <div className="col-lg-6">
                  <div dangerouslySetInnerHTML={SanitizeHtml(item.info)} />
                  <ul className="list-inline inline-contact-list">
                    {
                      item.website &&
                      <li className="list-inline-item">
                        <a href={item.website}>Website</a>
                      </li>
                    }
                    {
                      item.phone_number &&
                      <li className="list-inline-item">
                        <a href={`tel:${(item.phone_number || '').replace(/[^0-9]/g, '')}`}>{item.phone_number}</a>
                      </li>
                    }
                    {
                      item.email_address &&
                      <li className="list-inline-item">
                        <a href={`mailto:${item.email_address}`}>Email</a>
                      </li>
                    }
                  </ul>
                </div>
                <div className="col-lg-5">
                  <LightBox
                    items={[item.logo]}
                    button={(
                      <div className="result-media bg-cover" style={{ backgroundImage: `url(${buildThumbnailUrl(get(item, 'logo.contentUrl', ''), { width: 800, height: 800, preserve: true })})` }} />
                    )}
                  />
                </div>
              </div>
            </div>
          </section>
        ))
      }
      <Footer />
    </div>
  );
}

Financing.propTypes = {
  page: PropTypes.object,
};

Financing.defaultProps = {
  page: undefined,
};

export default withData({
  page: 'financing',
})(Financing);



// WEBPACK FOOTER //
// ./src/pages/Financing/index.js